import RestAPIUtils from "../react-core-lib/rest-api/rest-api-utils";

class UserApi {

  static USER_API_CONFIG = {
    apiUrl: process.env.REACT_APP_USER_API_URL,
    apiKey: process.env.REACT_APP_USER_API_KEY
  };

  static async updateClinicianData(bearerToken, payload) {
    const apiPath = `/v1/clinicians/update`;
    console.log(`updateClinicianData payload: ${JSON.stringify(payload)}`);
    return RestAPIUtils.makeWriteRequest(bearerToken, UserApi.USER_API_CONFIG, apiPath, 'PATCH', payload);
  }

  static async getClinicianImage(userId) {
    const apiPath = `/v1/clinicians/image`;
    const params = {
      userId: userId
    };
    // console.log(`getClinicianData payload: ${JSON.stringify()}`);
    return RestAPIUtils.makeGetRequestNoAuth(UserApi.USER_API_CONFIG, apiPath, params);
  }

  static async generatedPresignedUrls(bearerToken, payload) {
    const apiPath = `/v1/user/generate-presigned-urls`;
    console.log(`generatedPresignedUrls payload: ${JSON.stringify(payload)}`);
    return RestAPIUtils.makeWriteRequest(bearerToken, UserApi.USER_API_CONFIG, apiPath, 'POST', payload);
  }  

  static getContentPresignedUrlPayload() {
    return {
      "files": [
        {
          "method": "get",
          "key": "snapshot.zip"
        }
      ],
      "contentCategory": "content"
    };
  };

  static async generatedContentPresignedUrl(bearerToken) {
    const apiPath = `/v1/user/generate-presigned-urls`;
    const payload = UserApi.getContentPresignedUrlPayload();
    console.log(`generatedContentPresignedUrl payload: ${JSON.stringify(payload)}`);
    return RestAPIUtils.makeWriteRequest(bearerToken, UserApi.USER_API_CONFIG, apiPath, 'POST', payload);
  }

  static async getUpdatedContent(bearerToken, lastUpdated) {
    const apiPath = '/v1/user/query-updated-content';
    const params = {
      clinicType: 'physio',
      lastUpdated: lastUpdated
    };
    return RestAPIUtils.makeGetRequest(bearerToken, UserApi.USER_API_CONFIG, apiPath, params);
  }

  static async getContent(linkId, clinicType, locale) {    
    const apiPath = `/v1/patient/content/${linkId}`;      
    const params = {
      clinicType: clinicType,
      locale: locale
    };
    return RestAPIUtils.makeGetRequestNoAuth(UserApi.USER_API_CONFIG, apiPath, params);
  }  
}

export default UserApi;
